import { useRef, useCallback } from "react";
function useHandler(handler) {
  const ref = useRef();
  ref.current = handler;
  return useCallback(
    (...args) => ref.current ? ref.current(...args) : void 0,
    []
  );
}
export {
  useHandler
};
